export default __webpack_public_path__ + "static/media/HrithikSinhaCV.b6ee078e.pdf";